var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72323 5.52631C2.10472 5.17 2.70226 5.19219 3.05905 5.57193C3.41461 5.95413 3.39362 6.55087 3.01214 6.90595L2.17138 7.74557C1.79977 8.09326 1.21952 8.0834 0.859018 7.72338L0.831858 7.70365C0.481235 7.32022 0.502223 6.72718 0.878772 6.36963L1.72323 5.52631ZM1.01556 0.281331C1.37606 -0.0873129 1.9662 -0.0947104 2.33534 0.265303C2.33904 0.267769 2.34151 0.270235 2.34521 0.273934L4.64772 2.57457L6.74281 0.481064C7.11936 0.122283 7.71319 0.125982 8.08604 0.489694C8.15271 0.556272 8.2095 0.631481 8.25271 0.71532C8.46629 1.08643 8.40456 1.55247 8.10209 1.85577L6.01564 3.93818L8.28481 6.20553C8.66753 6.56677 8.68234 7.16967 8.31938 7.55065C8.31444 7.55805 8.30703 7.56298 8.30086 7.57037C7.93789 7.93162 7.35146 7.93902 6.97985 7.58517L6.93294 7.53955L1.03161 1.64741C0.671114 1.2652 0.663707 0.670935 1.01556 0.281331Z",
    fill: "#4569FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.45f7d9de.svg";
export { ForwardRef as ReactComponent };